import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ReactGA from 'react-ga4';
import { useThemeContext } from '../ThemeProvider';
import { NEXT_THEME_PREFERENCE, THEME_PREFERENCE_DISPLAY } from '../common/themePreference';

const ThemePreferenceIconButton = () => {
	const { themePreference, setThemePreference } = useThemeContext();
	const { icon, label } = THEME_PREFERENCE_DISPLAY[themePreference];

	const handleClick = () => {
		const nextPreference = NEXT_THEME_PREFERENCE[themePreference];
		setThemePreference(nextPreference);
		ReactGA.event({
			category: 'UI',
			action: `ThemePreferenceChanged: ${nextPreference}`,
		});
	};

	return (
		<Tooltip title={label}>
			<IconButton onClick={handleClick} aria-label={label}>
				{icon}
			</IconButton>
		</Tooltip>
	);
};

export default ThemePreferenceIconButton;
